import { useParams, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Dashboard, {
  DashboardRow,
  DashboardSection,
  DashboardSectionTitle,
} from '@g17eco/molecules/dashboard';
import { SubsidiaryGroupsTable } from './SubsidiaryGroupsTable';
import NotAuthorised from '@routes/not-authorised';
import { Breadcrumbs } from '@g17eco/molecules/breadcrumbs';
import { generateUrl } from '@routes/util';
import { ROUTES } from '@constants/routes';
import { isRootOrg } from '@selectors/initiative';

interface RouteParams {
  initiativeId: string;
}

export const ManageSubsidiaryGroupsRoute = () => {
  const { initiativeId } = useParams<RouteParams>();
  const isRoot = useSelector(isRootOrg);

  if (!initiativeId) {
    return <NotAuthorised />;
  }

  // Only root initiative can access this page
  if (!isRoot) {
    return <Redirect to={generateUrl(ROUTES.NAVIGATE_BY_MAP, { initiativeId })} />;
  }

  const rootUrl = generateUrl(ROUTES.NAVIGATE_BY_MAP, { initiativeId });
  const breadcrumbs = [{ label: 'Manage Subsidiary Groups' }];

  return (
    <Dashboard>
      <DashboardRow>
        <Breadcrumbs breadcrumbs={breadcrumbs} rootLabel='Organisation map' rootUrl={rootUrl} />
      </DashboardRow>
      <DashboardSectionTitle title='Manage subsidiary groups' subtitle='Create and manage groups of subsidiaries by categorising reporting levels into relevant groups, streamlining  workflow and functionality on the platform.' />
      <DashboardSection>
        <SubsidiaryGroupsTable initiativeId={initiativeId} />
      </DashboardSection>
    </Dashboard>
  );
};
